import { ILoggerEvent } from '~/src/dash/api/live_logs/event';
import { createUrl, restPost } from '~/src/dash/api/rest';
import { DEMO_ACCOUNTS } from '~/src/dash/globals/constants';

export async function generalGetLiveLogs<T>(
  event: Partial<ILoggerEvent>,
  publisherID: string,
  username: string,
): Promise<[T | undefined, string | undefined]> {
  let reqUrl = createUrl('/live_logs', publisherID);
  if (DEMO_ACCOUNTS.includes(username)) {
    reqUrl += '&obfuscate=true';
  }

  try {
    return [(await restPost<T>(reqUrl, event)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

// new API version for fetching live logs
// need to separate the response from error
export async function generalGetLiveLogsV2<T>(
  event: Partial<ILoggerEvent>,
  publisherID: string,
  username: string,
): Promise<T | undefined> {
  let reqUrl = createUrl('/live_logs', publisherID);
  if (DEMO_ACCOUNTS.includes(username)) {
    reqUrl += '&obfuscate=true';
  }

  try {
    return (await restPost<T>(reqUrl, event)).parsedBody;
  } catch (err) {
    throw err;
  }
}

export function getBidRequestLogsQuery(headerbidderID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.BidRequest.Bids[0].HeaderbidderId)
  return {
    type: 3029,
    bid_request: {
      bids: [
        {
          headerbidder_id: headerbidderID,
        },
      ],
    },
  };
}

export function getEndpointRequestLogsQuery(siteUUID: string): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.BidResponse.HeaderbidderId)
  return {
    type: 1011,
    site_uuid: siteUUID,
  };
}

export function getVMAPPlaylistEndpointRequestLogsQuery(siteUUID: string): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.BidResponse.HeaderbidderId)
  return {
    type: 3101,
    site_uuid: siteUUID,
  };
}

export function getVMAPPlaylistEndpointResponseLogsQuery(siteUUID: string): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.BidResponse.HeaderbidderId)
  return {
    type: 3104,
    site_uuid: siteUUID,
  };
}

export function getBidResponseLogsQuery(headerbidderID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.BidResponse.HeaderbidderId)
  return {
    type: 3027,
    bid_response: {
      headerbidder_id: headerbidderID,
    },
  };
}

export function getEndpointResponseLogsQuery(siteUUID: string): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.BidResponse.HeaderbidderId)
  return {
    type: 3028,
    site_uuid: siteUUID,
  };
}

// Stream
export function getStreamStartLogsQuery(networkID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.NetworkId)
  return {
    type: 4000,
    network_id: networkID,
  };
}

export function getStreamResponseLogsQuery(networkID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.NetworkId)
  return {
    type: 4012,
    network_id: networkID,
  };
}

export function getStreamPodRequestQuery(networkChannelID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.NetworkChannelId)
  return {
    type: 4001,
    network_channel_id: networkChannelID,
  };
}

export function getStreamPodFilledQuery(networkChannelID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.NetworkChannelId)
  return {
    type: 4002,
    network_channel_id: networkChannelID,
  };
}

export function getStreamAdFilledQuery(networkChannelID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.NetworkChannelId)
  return {
    type: 4004,
    network_channel_id: networkChannelID,
  };
}

export function getStreamAdFilledInVideoUnitQuery(inVideoUnitID: number): Partial<ILoggerEvent> {
  // key is: return fmt.Sprintf("%s_%d", ev.Type.String(), ev.Stream.InVideoUnitId)
  return {
    type: 4004,
    stream: {
      in_video_unit_id: inVideoUnitID.toString(),
    },
  };
}

// inventory routing live logs
export function getInventoryRouteEndpointRequestQuery(
  inventoryRouteID: number,
): Partial<ILoggerEvent> {
  return {
    type: 7000,
    inventory_route_id: inventoryRouteID,
  };
}

export function getInventoryRouteEndpointResponseQuery(
  inventoryRouteID: number,
): Partial<ILoggerEvent> {
  return {
    type: 7002,
    inventory_route_id: inventoryRouteID,
  };
}

export function getDestinationEndpointRequestQuery(destinationID: number): Partial<ILoggerEvent> {
  return {
    type: 7003,
    destination_id: destinationID,
  };
}

export function getDestinationEndpointResponseQuery(destinationID: number): Partial<ILoggerEvent> {
  return {
    type: 7004,
    destination_id: destinationID,
  };
}

// campaign live logs (line items)
export function getAdserverInventoryRequestQuery(campaignID: string): Partial<ILoggerEvent> {
  return {
    type: 630,
    campaign_id: parseInt(campaignID, 10),
  };
}

export function getAdserverFilledResponseQuery(campaignID: string): Partial<ILoggerEvent> {
  return {
    type: 623,
    campaign_id: parseInt(campaignID, 10),
  };
}
